import { IAugmentedJQuery } from 'angular';
import { ICommand, IDatasource, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { DEEMPHASIZE_DROP_AREA, EMPHASIZE_DROP_AREA } from '../../../plan/constants/event_names';
import { APDegreeMapQuery } from '../degree_map/queries/ap_degree_map_query';

interface IApSearchCourseSuggestion {
  text: string;
  value: string;
  suggestionText: (searchQuery: string) => string;
  resultsTitle: (searchQuery: string) => string;
}
interface ISearchCategorySuggestionList {
  value: string;
  label: string;
}
class SearchCourse {
  private resultsText: string = '';
  private showResults = false;
  private searchTerm: string = '';
  private searchTermValue: string = '';
  private SearchCategorySuggestionList: ISearchCategorySuggestionList[] = [];
  private isLoadingResults = false;
  private hasDegreeMap = true;
  private courseSearchCategory: Record<string, IApSearchCourseSuggestion> = {
    ALL: {
      value: 'all',
      text: 'All',
      suggestionText: (searchQuery) => `Search for ${searchQuery} in All`,
      resultsTitle: (searchQuery) => `'${searchQuery}'`
    },
    TITLE: {
      value: 'title',
      text: 'Title',
      suggestionText: (searchQuery) => `Search for ${searchQuery} by Title`,
      resultsTitle: (searchQuery) => `'${searchQuery}' by Title`
    },
    DESC: {
      value: 'desc',
      text: 'Description',
      suggestionText: (searchQuery) => `Search for ${searchQuery} by Description`,
      resultsTitle: (searchQuery) => `'${searchQuery}' by Description`
    },
    CD: {
      value: 'cd',
      text: 'Course ID',
      suggestionText: (searchQuery) => `Search for ${searchQuery} by Course Id`,
      resultsTitle: (searchQuery) => `'${searchQuery}' by Course Id`
    }
  };

  private courseSearchCategoryList: IApSearchCourseSuggestion[] = _4.values(this.courseSearchCategory);

  constructor(
    private ngApCourseSearchQuery: any,
    private apGetCourseSearchCommand: ICommand,
    private apGetCourseSearchClearCommand: ICommand,
    private ngComponentCommunicatorService: CommunicatorService,
    private ngAPDegreeMapQuery: APDegreeMapQuery,
    private $element: ng.IAugmentedJQuery
  ) {
    this.apGetCourseSearchClearCommand();
    this.hasDegreeMap = !this.isDegreeMapEmpty();
  }

  emphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(EMPHASIZE_DROP_AREA);
  }
  deEmphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(DEEMPHASIZE_DROP_AREA);
  }
  onQueryChange(event: any) {
    this.searchTermValue = this.searchTerm;
    this.searchTerm = event.detail.value;
    this.SearchCategorySuggestionList = this.SearchCategorySuggestionOptions(this.searchTerm);
  }

  isDegreeMapEmpty() {
    return this.ngAPDegreeMapQuery.result.isDegreeMapEmpty;
  }

  SearchCategorySuggestionOptions(searchQuery: string) {
    return this.courseSearchCategoryList.map((category) => ({
      label: category.suggestionText(searchQuery),
      value: category.value
    }));
  }

  onSelectSearchQuery(event: any) {
    this.resetSearchFlags();
    if (this.isSearchQueryValid) {
      const searchCaregory = event.detail.value;
      this.apGetCourseSearchCommand(this.searchTermValue, searchCaregory).then(() => {
        const key = _4.upperCase(searchCaregory);
        this.resultsText = this.courseSearchCategory[key].resultsTitle(this.searchTermValue);
        this.isLoadingResults = false;
        this.showResults = true;
        this.clearSerchKeyword();
      });
    } else {
      this.apGetCourseSearchClearCommand();
      this.isLoadingResults = false;
      this.clearSerchKeyword();
      return;
    }
  }

  clearSerchKeyword() {
    const element = this.$element.find(`#find-course-type-ahead`);
    const searchElement = _4.first(element);
    if (searchElement) {
      searchElement['searchValue'] = '';
    }
    this.searchTermValue = '';
    this.searchTerm = '';
  }
  get isSearchQueryValid() {
    return this.searchTermValue.length > 2;
  }
  resetSearchFlags() {
    this.isLoadingResults = true;
    this.resultsText = '';
    this.showResults = false;
  }
}

angular.module('capability-ng-academic-planner').component('searchCourse', {
  templateUrl: 'capability-ng-academic-planner/src/plan/components/planner_search/search_course.html',
  bindings: {},
  controller: SearchCourse
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/planner_search/search_course.ts